const PRODUCT_COLOR_SEPARATOR = '&mdash;';

export function parseProductNameAndColor(productNameAndColor: string): [name: string, color: string] {
    return productNameAndColor.split(PRODUCT_COLOR_SEPARATOR).map((part) => part.trim()) as [string, string];
}
